<template>
  <!-- eslint-disable vue/no-v-html vue/camelcase -->
  <div class="review-request-page">
    <template v-if="!loadingLandingPage && business !== null && typeof business === 'object'">
      <div class="review-request-container">
        <div class="review-request-card">
          <div class="card-header">
            <h1 class="card-title">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="title-icon">
                <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
                <circle cx="9" cy="7" r="4"></circle>
                <path d="M22 21v-2a4 4 0 0 0-3-3.87"></path>
                <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
              </svg>
              Add Review Request Contact
            </h1>
            <p class="card-description">Add a contact for {{ business.business_name }}</p>
          </div>
          <div class="card-body">
            <form class="review-request-form" @submit.prevent="submitForm">
              <div class="form-grid">
                <div class="form-field">
                  <label class="form-label" for="firstName">First Name</label>
                  <input
                    id="firstName"
                    v-model="firstName"
                    type="text"
                    class="form-input"
                    required
                    placeholder="Enter first name"
                  />
                </div>
                <div class="form-field">
                  <label class="form-label" for="lastName">Last Name</label>
                  <input
                    id="lastName"
                    v-model="lastName"
                    type="text"
                    class="form-input"
                    placeholder="Enter last name"
                  />
                </div>
              </div>
              <div class="form-field rr-form">
                <label class="form-label" for="cellphone">Cell Phone</label>
                <VuePhoneNumberInput
                  ref="vue_tel"
                  v-model="cellphone"
                  :error="cellphone && !phoneObject.isValid"
                  valid-color="#22c55e"
                  class="phone-input-wrapper"
                  @update="phoneUpdated"
                />
              </div>
              <div class="form-field">
                <label class="form-label" for="email">Email</label>
                <input
                  id="email"
                  v-model="email"
                  type="email"
                  class="form-input"
                  placeholder="Enter email address"
                />
              </div>
              <div class="form-field">
                <label class="form-label" for="employee">Employee</label>
                <select id="employee" v-model="employee_id" class="form-select">
                  <option v-for="(employee, i) in employees" :key="i" :value="employee.id ?? employee.employee_id">
                    {{ employee.name }}
                  </option>
                </select>
              </div>
              <div v-if="errorMessage !== ''" class="form-error">{{ errorMessage }}</div>
              <div class="form-actions">
                <button type="submit" class="submit-btn" :disabled="formWorking">
                  <b-spinner v-if="formWorking" small class="mr-2" />
                  Submit
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </template>
    <div v-else-if="status === 404" class="error-page">
      <h1 class="error-title">Business Not Found</h1>
      <p class="error-message">The requested business could not be found.</p>
    </div>
    <div v-else class="loading-page">
      <b-spinner class="loading-spinner" />
      <p class="loading-text">Loading...</p>
    </div>
  </div>
</template>

<script>
import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';
import Vue from 'vue';

export default {
  components: {
    VuePhoneNumberInput,
  },
  props: {},
  data() {
    return {
      loadingLandingPage: false,
      formWorking: false,
      business: null,
      status: 200,
      firstName: '',
      lastName: '',
      cellphone: null,
      email: '',
      employee_id: null,
      employees: [],
      country: 'US',
      phoneObject: {
        e164: '',
        countryCode: '',
        isValid: false,
      },
      errorMessage: '',
    };
  },
  metaInfo() {
    return {
      title: 'Review ' + (this.business?.business_name ?? ''),
      meta: [{ name: 'og:title', content: 'Review ' + (this.business?.business_name ?? '') }],
    };
  },
  computed: {},
  mounted() {
    this.getBusiness();
  },
  methods: {
    phoneUpdated(phone) {
      this.phoneObject = phone;
    },
    submitForm() {
      if (this.$route.params.unique_id) {
        this.errorMessage = '';
        if (this.cellphone && !this.phoneObject.isValid) {
          this.errorMessage = 'Phone is not valid.';
          return;
        }
        this.formWorking = true;
        this.$store
          .dispatch('landingPage/submitContact', {
            first_name: this.firstName,
            last_name: this.lastName,
            email: this.email,
            cell_phone: this.phoneObject.e164,
            country: this.phoneObject.countryCode,
            business_id: this.business.id,
            employee_id: this.employee_id,
          })
          .then((res) => {
            this.formWorking = false;
            if (res.success) {
              this.status = res?.data?.status;
              this.loadingLandingPage = false;
              Vue.$toast.open({
                message: 'Contact Added',
                type: 'success',
                duration: 5000,
              });
              this.phoneObject.e164 = '';
              this.firstName = '';
              this.lastName = '';
              this.email = '';
              this.cellphone = '';
            } else {
              Vue.$toast.open({
                message: res.message,
                type: 'error',
                duration: 5000,
              });
            }
          })
          .catch((error) => {
            console.log(error);
            this.loadingLandingPage = false;
            this.formWorking = false;
          });
      }
    },
    getBusiness() {
      this.loadingLandingPage = true;
      if (this.$route.params.unique_id) {
        this.$store
          .dispatch('landingPage/getBusiness', this.$route.params.unique_id)
          .then((res) => {
            this.business = res?.data?.business;
            this.employees = [
              { employee_id: null, id: null, name: 'Unknown' },
              ...(res?.data?.business?.employees ?? []),
            ];
            this.status = res?.data?.status;
            this.loadingLandingPage = false;
          })
          .catch((error) => {
            console.log(error);
            this.loadingLandingPage = false;
          });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.review-request-page {
  min-height: 100vh;
  background: #f3f4f6;
  padding: 40px 24px;
}

.review-request-container {
  max-width: 560px;
  margin: 0 auto;
}

.review-request-card {
  border-radius: 8px;
  border: 1px solid #e5e7eb;
  background: #ffffff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  overflow: hidden;
}

.card-header {
  padding: 28px 28px 20px;
  background: #f9fafb !important;
  border-bottom: 1px solid #e5e7eb !important;

  .card-title {
    font-size: 22px;
    font-weight: 600;
    color: #111827 !important;
    margin: 0;
    display: flex;
    align-items: center;
    gap: 10px;

    .title-icon {
      width: 24px;
      height: 24px;
      color: #3b82f6;
      flex-shrink: 0;
    }
  }

  .card-description {
    font-size: 14px;
    color: #4b5563 !important;
    margin: 8px 0 0 0;
  }
}

.card-body {
  padding: 28px;
}

.review-request-form {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.form-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;

  @media (max-width: 640px) {
    grid-template-columns: 1fr;
  }
}

.form-field {
  display: flex;
  flex-direction: column;
}

.form-label {
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 8px;
  color: #111827;
}

.form-input,
.form-select {
  width: 100%;
  height: 40px;
  border-radius: 6px;
  border: 1px solid #d1d5db;
  background: #ffffff;
  padding: 0 12px;
  font-size: 14px;
  color: #111827;
  transition: border-color 0.15s, box-shadow 0.15s;

  &:focus {
    outline: none;
    border-color: #3b82f6;
    box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.1);
  }

  &::placeholder {
    color: #9ca3af;
  }
}

.form-select {
  cursor: pointer;
  appearance: auto;
}

.form-error {
  font-size: 14px;
  color: #dc2626;
  padding: 8px 0;
}

.form-actions {
  margin-top: 8px;
}

.submit-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 44px;
  padding: 0 32px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 600;
  background: #3b82f6;
  color: #fff;
  border: none;
  cursor: pointer;
  transition: background 0.2s;

  &:hover:not(:disabled) {
    background: #2563eb;
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
}

.error-page {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #3b82f6;
  color: #fff;
  padding: 24px;
  text-align: center;
}

.error-title {
  font-size: 28px;
  font-weight: 700;
  margin: 0 0 12px 0;
}

.error-message {
  font-size: 16px;
  opacity: 0.9;
  margin: 0;
}

.loading-page {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #f3f4f6;
  padding: 24px;
}

.loading-spinner {
  margin-bottom: 16px;
}

.loading-text {
  font-size: 14px;
  color: #6b7280;
  margin: 0;
}
</style>

<style lang="scss">
.rr-form {
  .phone-input-wrapper {
    .country-selector__input,
    .input-tel__input {
      border-radius: 6px;
      border-color: #d1d5db;
      height: 40px;
      font-size: 14px;
    }

    .input-tel.is-valid {
      .input-tel__input {
        border-color: #22c55e !important;
      }
    }

    .input-tel__input::placeholder {
      visibility: hidden;
    }
  }
}
</style>
